import { render, staticRenderFns } from "./return-details.vue?vue&type=template&id=05091912&scoped=true"
import script from "./return-details.vue?vue&type=script&lang=js"
export * from "./return-details.vue?vue&type=script&lang=js"
import style0 from "./return-details.vue?vue&type=style&index=0&id=05091912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05091912",
  null
  
)

export default component.exports